import { apiService } from './api'

export const transactionsApi = {
  // Get all transactions for the business
  async getTransactions(filters = {}) {
    const params = new URLSearchParams()
    
    if (filters.business_id) params.append('business_id', filters.business_id)
    if (filters.startDate) params.append('start_date', filters.startDate)
    if (filters.endDate) params.append('end_date', filters.endDate)
    if (filters.start_date) params.append('start_date', filters.start_date)
    if (filters.end_date) params.append('end_date', filters.end_date)
    if (filters.customer_id) params.append('customer_id', filters.customer_id)
    if (filters.payment_method) params.append('payment_method', filters.payment_method)
    if (filters.status) params.append('status', filters.status)
    if (filters.page) params.append('page', filters.page)
    if (filters.limit) params.append('limit', filters.limit)
    if (filters.search) params.append('search', filters.search)
    
    const response = await apiService.get(`/transactions?${params}`)
    return response // API service already returns response.data
  },

  // Get transaction by ID
  async getTransaction(transactionId) {
    const response = await apiService.get(`/transactions/${transactionId}`)
    return response // API service already returns response.data
  },

  // Create new transaction (sale)
  async createTransaction(transactionData) {
    const response = await apiService.post('/transactions', transactionData)
    return response // API service already returns response.data
  },

  // Update transaction
  async updateTransaction(transactionId, transactionData) {
    const response = await apiService.put(`/transactions/${transactionId}`, transactionData)
    return response // API service already returns response.data
  },

  // Delete transaction
  async deleteTransaction(transactionId) {
    const response = await apiService.delete(`/transactions/${transactionId}`)
    return response // API service already returns response.data
  },

  // Get sales report with statistics
  async getSalesReport(period = 'today') {
    const response = await apiService.get(`/transactions/reports/sales?period=${period}`)
    return response // API service already returns response.data
  },

  // Get daily sales summary
  async getDailySummary(date) {
    const response = await apiService.get(`/transactions/summary/daily?date=${date}`)
    return response // API service already returns response.data
  },

  // Get monthly sales summary
  async getMonthlySummary(year, month) {
    const response = await apiService.get(`/transactions/summary/monthly?year=${year}&month=${month}`)
    return response // API service already returns response.data
  },

  // Get sales analytics
  async getSalesAnalytics(period = '7d') {
    const response = await apiService.get(`/transactions/analytics?period=${period}`)
    return response // API service already returns response.data
  },

  // Process refund
  async processRefund(transactionId, refundData) {
    const response = await apiService.post(`/transactions/${transactionId}/refund`, refundData)
    return response // API service already returns response.data
  },

  // Get receipt data
  async getReceipt(transactionId) {
    const response = await apiService.get(`/transactions/${transactionId}/receipt`)
    return response // API service already returns response.data
  },

  // Send receipt via email
  async sendReceipt(transactionId, email) {
    const response = await apiService.post(`/transactions/${transactionId}/send-receipt`, { email })
    return response // API service already returns response.data
  },

  // Record payment for credit invoice
  async recordPayment(paymentData) {
    const response = await apiService.post('/transactions/payment', paymentData)
    return response // API service already returns response.data
  },


}

export default transactionsApi
